import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Subject, tap } from 'rxjs'
import { AngularFireDatabase, AngularFireList } from '@angular/fire/compat/database'
import { AngularFireMessaging } from '@angular/fire/compat/messaging'
import { TranslateService } from '@ngx-translate/core'
import { ApiEndPoint } from 'src/app/shared/constants/apis.constant'
import { notificationsFilter } from '../models/notification'
import { environment } from 'src/environments/environment'

@Injectable({
	providedIn: 'root',
})
export class NotificationService {
	fcmChannel = new BroadcastChannel('fcm-channel')
	messageReceivingSubject: Subject<any> = new Subject()
	messagesRef!: AngularFireList<any>
	dbPath = '/messages'
	token = ''
	constructor(
		private http: HttpClient,
		private db: AngularFireDatabase,
		private fbMessaging: AngularFireMessaging,
		private translate: TranslateService
	) {




		}
	

	ngOnInit(): void {

		this.requestPermission()
		this.listen()
		this.messagesRef = this.db.list(this.dbPath)
		
	}


 async	requestPermission() {
		this.fbMessaging.requestToken.subscribe(
		(token:any) => {
			if (token) {
				this.token = token
				this.http
					.post(
						'https://iid.googleapis.com/iid/v1/' +
						token +
						'/rel/topics/' +
						`${this.translate.currentLang == 'en' ? 'adwAdminEn' : 'adwAdminAr'
						}`,
						{},
						{
							headers: {
								Authorization: environment.firebaseConfig.serverKey,
								'Content-Type': 'application/json',
								Anonymous: 'custom',
							},
						}
					)
					.subscribe((res) => { 
					       }, (error) => {

        });
    
			}
		},

		);
		}
	listen() {
		this.fbMessaging.messages.subscribe((payload: any) => {
			this.messageReceivingSubject.next(payload)
		})
		this.fcmChannel.onmessage = (message) => {
			this.messageReceivingSubject.next(message.data)
	
		}
	}


	getNotificationList(
		notFilter: notificationsFilter
	) {
		return this.http.get(
			`${ApiEndPoint.GetAllNotificationApi}?NotificationTap=${notFilter?.NotificationTap}&IsRead=${notFilter?.IsRead}&Paging.PageNumber=${notFilter.Paging.PageNumber}&Paging.PageSize=${notFilter.Paging.PageSize}`
		)
	}

	markAsRead(body: number[]) {
		return this.http.post(`${ApiEndPoint.MarkAsReadApi}`, body)
	}
}
